/**
 * Entry point: wires the manifest and GameScene into the SDK.
 */
import { bootGame } from '@platform/sdk';
import GameScene from './GameScene.js';
import manifest from '../manifest.json';

bootGame({
  manifest,
  GameScene,
  parent: 'game'
});
